import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare global {
  interface Window { CONSENT: any; }
}
@Injectable()
export class ConsentService {
  backendURL: string;
  corpToken: string;
  guid: string;
  privateLabelId: string;
  entity: string;

  constructor(private http: HttpClient) {
    this.backendURL = window.CONSENT.session.backendUrl;
    this.corpToken = window.CONSENT.session.corpToken;
    this.guid = window.CONSENT.session.guid;
    this.privateLabelId = window.CONSENT.session.privateLabelId;
    this.entity = window.CONSENT.session.entity;
  }

  getFormOptions() {
    const urlEncodedGuid = encodeURIComponent(this.guid);
    const url = `${this.backendURL}/${this.corpToken}/consent?guid=${urlEncodedGuid}&privateLabelId=${this.privateLabelId}&entity=${this.entity}`;
    return this.http.get(url);
  }
  save(formValue: any) {
    const url = `${this.backendURL}/${this.corpToken}/consent`;
    const body = {
        guid: this.guid,
        consentTypes: formValue,
        privateLabelId: parseInt(this.privateLabelId)
    };
    return this.http.post(url, body);
  }


}



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/app/consent/consent.service.ts